export default {
  "content": "<path d=\"M5 1v2a2 2 0 11-2 2H1a4 4 0 104-4z\" fill=\"#F2A53F\"/>",
  "attrs": {
    "data-name": "Layer 1",
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "10",
    "height": "10"
  }
};